import { Rect } from 'widgets/Lines/LineWidget/LineWidget.types';

/**
 * Calculates the midpoint between two rectangles along the x-axis if there's no overlap.
 * Returns null if the rectangles overlap in the x direction.
 *
 * @param rect1 The first rectangle.
 * @param rect2 The second rectangle.
 * @returns The midpoint value if the rectangles don't overlap, or null if they do.
 */
export const generateMidXBetweenRects = (rect1: Rect, rect2: Rect): number | null => {
  if (rect1.x + rect1.width < rect2.x || rect2.x + rect2.width < rect1.x) {
    // If rect1 is to the left of rect2
    if (rect1.x < rect2.x) {
      return parseFloat(((rect1.x + rect1.width + rect2.x) / 2).toFixed(1));
    }
    // If rect1 is to the right of rect2
    else {
      return parseFloat(((rect2.x + rect2.width + rect1.x) / 2).toFixed(1));
    }
  }
  return null;
};

/**
 * Calculates the midpoint between two rectangles along the y-axis if there's no overlap.
 * Returns null if the rectangles overlap in the y direction.
 *
 * @param rect1 The first rectangle.
 * @param rect2 The second rectangle.
 * @returns The midpoint value if the rectangles don't overlap, or null if they do.
 */
export const generateMidYBetweenRects = (rect1: Rect, rect2: Rect): number | null => {
  if (rect1.y + rect1.height < rect2.y || rect2.y + rect2.height < rect1.y) {
    // If rect1 is above rect2
    if (rect1.y < rect2.y) {
      return parseFloat(((rect1.y + rect1.height + rect2.y) / 2).toFixed(1));
    }
    // If rect1 is below rect2
    else {
      return parseFloat(((rect2.y + rect2.height + rect1.y) / 2).toFixed(1));
    }
  }
  return null;
};
